export default __webpack_public_path__ + "static/media/i041vk.7d5b2ce1.webp";